// 買い物リスト
import NativeClient from "@/client/native-client";
import { WEB_CONTENT_CONST } from "@/const/web_content-const";

/** 通信IDの省略 */
export const encodeCommunicationID = (communicationId: string) => {
  const fullLength = communicationId.length;
  const preString = communicationId.slice(0, fullLength - 4);
  const lastChar = communicationId.slice(fullLength - 1, fullLength);
  NativeClient.sendDebugLog("encodeCommunicationID preString = " + preString + ", lastChar = " + lastChar);
  return preString + lastChar;
};

/** WebコンテンツのURL生成 */
export const generateFridgeSettingsPopupWebContentURL = (pageId: string, communicationId: string) => {
  const encodedCommunicationID = encodeCommunicationID(communicationId);
  const url = process.env.VUE_APP_KITCHEN_APPLIANCES_URL + WEB_CONTENT_CONST.WEB_CONTENT_ROOT_FOLDER + pageId + "/" + encodedCommunicationID + ".html";
  NativeClient.sendDebugLog("generateFridgeSettingsPopupWebContentURL url = " + url);
  return url;
};